<template>
  <Visitor>
    <main class="flex flex-col justify-center py-8 sm:px-6 lg:px-8">
      <div class="sm:mx-auto">
          <img
            class="mx-auto h-36 w-auto"
            src="../../assets/logo_circulo.png"
            alt="Workflow"
          />
        <h2
          class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
        >
          Crear Cuenta
        </h2>
      </div>

      <div class="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div>
            <label
              for="username"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Usuario
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="username"
                v-model="username"
                type="text"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
              <small v-if="error_username" class="text-red-600">{{
                error_username
              }}</small>
          </div>

          <div class="mt-2">
            <label
              for="email"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Correo
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="email"
                v-model="email"
                type="email"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
              <small v-if="error_email" class="text-red-600">{{
                error_email
              }}</small>
          </div>

          <!--div class="mt-2">
            <label
              for="password"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Contraseña
            </label>
            <div class="mt-1 flex rounded-md shadow-sm">
              <input
                id="password"
                :type="showPassword?'text':'password'"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-l-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
              <button
              @click="showPassword = !showPassword"
                class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-r-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
              >
                <IconSvg
                  :solid="true"
                  :icon="showPassword?'eye-off':'eye'"
                  myClass="h-5 w-5 text-gray-400"
                />
              </button>
            </div>
          </div-->

          <div class="mt-2">
            <label
              for="password"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Contraseña
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="password"
                v-model="password"
                type="password"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-l-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
              <small v-if="error_password" class="text-red-600">{{
                error_password
              }}</small>
          </div>

          <div class="mt-2">
            <label
              for="repeat_password"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Repetir Contraseña
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <input
                id="repeat_password"
                v-model="repeat_password"
                type="password"
                required
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-l-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              />
            </div>
              <small v-if="error_repeat_password" class="text-red-600">{{
                error_repeat_password
              }}</small>
          </div>

          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <AnimatedButton
                content="Registrar"
                color="primary"
                @onClick="submitSignup()"
                :isLoading="buttonLoading"
              ></AnimatedButton>
            </span>
          </div>

          <div class="mt-4 flex text-center justify-between">
            <div class="text-sm leading-5">
              <span class="font-medium">Al registrarte, estas aceptando los términos y condiciones de uso del servicio KusaWasi </span>
            </div>
          </div>

          <div class="mt-6 flex text-right justify-between">
            <div class="text-base leading-5">
              <span class="font-medium">¿Ya tienes cuenta? </span>
              <router-link
                to="/login"
                class="font-medium text-primary-600 hover:text-primary-500 focus:outline-none focus:underline transition ease-in-out duration-150"
              >
                ¡Inicia sesión!
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </main>
  </Visitor>
</template>

<script>
import api from "../../api";

import Visitor from "../Layouts/Visitor";
import AnimatedButton from "../../components/AnimatedButton.vue";

export default {
  name: "JoinUs",
  components: {
    Visitor,
    AnimatedButton
  },
  data: function() {
    return {
      hasError: false,
      buttonLoading: false,

      username: "",
      email: "",
      password: "",
      repeat_password: "",

      error_username: "",
      error_email: "",
      error_password: "",
      error_repeat_password: "",
    };
  },
  methods: {
    async submitSignup() {
      this.validateSubmit();
      if (this.hasError) return;
      this.buttonLoading = true;
      let response = await api.post(`/signup`, {
        username: this.username,
        email: this.email,
        password: this.password
      })
      if (!response.ok) {
        this.buttonLoading = false;
        return this.$toast.open({
          message: response.error || 'Ocurrió un error, vuelva a intentarlo',
          type: "error",
          duration: 8000,
          dismissible: true
        });
      }
      this.$toast.open({
        message: 'Registro correcto',
        type: "success",
        duration: 8000,
        dismissible: true
      });
      localStorage.setItem('jwt_token', response.data.jwt_token)
      localStorage.setItem('user_id', response.data.user_id)
      localStorage.setItem('user_name', response.data.user_name)
      // user_level: worker (Trabajador), customer (Cliente)
      localStorage.setItem('user_level', response.data.user_level)
      this.$router.push("/worker/profile/edit");
    },
    validateSubmit() {
      this.hasError = false;
      if (this.username == "") {
        this.hasError = true;
        this.error_username = "Campo obligatorio";
      } else this.error_username = "";
      if (this.email == "") {
        this.hasError = true;
        this.error_email = "Campo obligatorio";
      } else if (!this.email.includes('@') || !this.email.includes('.') || this.email.length < 5) {
        this.hasError = true;
        this.error_email = "Correo no válido";
      } else this.error_email = "";
      if (this.password == "") {
        this.hasError = true;
        this.error_password = "Campo obligatorio";
      } else this.error_password = "";
      if (this.repeat_password == "") {
        this.hasError = true;
        this.error_repeat_password = "Campo obligatorio";
      } else if (this.repeat_password != this.password) {
        this.hasError = true;
        this.error_repeat_password = "Las contraseñas no coinciden";
      } else this.error_repeat_password = "";
    }
  }
};
</script>